import React, { useEffect, useState, useRef, useContext } from 'react';
import { Card, CardHeader, CardHeaderBtn, CardBody } from '../../components/card/card.jsx';
import { NavScrollTo } from '../../components/nav-scroll-to/nav-scroll-to.jsx';
import Highlight from 'react-highlight';
import { externalAddress, AppSettings } from '../../config/app-settings.js';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import 'datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css';
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css';

const $ = require('jquery');
$.DataTable = require('datatables.net');
require('datatables.net-bs5');
require('datatables.net-buttons');
require('datatables.net-buttons/js/buttons.colVis.min.js');
require('datatables.net-buttons/js/buttons.html5.min.js');
require('datatables.net-buttons/js/buttons.print.min.js');
require('datatables.net-buttons-bs5');
require('datatables.net-responsive');
require('datatables.net-responsive-bs5');
require('datatables.net-fixedcolumns');
require('datatables.net-fixedcolumns-bs5');

function TablePlugins() {

	const context = useContext(AppSettings);

	const [code1, setCode1] = useState();
	const tableRef = useRef(null);
	const tableUsuarios = useRef(null);
	const tableEstrategias = useRef(null);
	
	useEffect(() => {

		context.setAppHeaderNone(false);
		context.setAppSidebarNone(true);
		context.setAppContentFullHeight(false);
		
		fetch(externalAddress+'/api/biblioteca/analytics', {
			headers: {
			'HTTP-AUTHORIZATION': localStorage.getItem("bs_token")
		}}).then(res => {
			if (res.status == 401) {
				localStorage.clear();
				window.location.href = 'https://botspot.com.br/login?to=/analytics';
				//window.location.href = 'http://localhost:3000/login?to=/analytics';
			}
			if (res.status == 403) {
				localStorage.clear();
				window.location.href = 'https://botspot.com.br/login?to=/analytics';
				//window.location.href = 'http://localhost:3000/login?to=/analytics';
			}
			return res.json()
		})
		.then((result) => { 
			console.log('result')
			console.log(result)

			//var dataSetDownloads = result.downloads
			var dataSetDownloads = result.analytics.downloads.map(item => [
				item.nome,
				item.email,
				item.estrategia,
				item.data
			]);

			var dataSetUsuarios = result.analytics.usuarios.map(item => [
				item.nome,
				item.email,
				item.qtd
			]);

			var dataSetEstrategias = result.analytics.estrategias.map(item => [
				item.estrategia,
				item.qtd
			]);

			//console.log('dataSetDownloads')
			//console.log(dataSetDownloads)

			tableRef.current = $('#datatableDefault').DataTable({
				//dom: "<'row mb-3'<'col-md-4'l><'col-md-8 text-right'<'d-lg-flex justify-content-end'fB>>>t<'row align-items-center mt-3'<'mr-auto col-md-6 mb-3 mb-md-0'i><'mb-0 col-md-6'p>>",
				lengthMenu: [ 10, 20, 30, 40, 50 ],
				responsive: true,
				data: dataSetDownloads
			});

			tableUsuarios.current = $('#usuariosDownload').DataTable({
				//dom: "<'row mb-3'<'col-md-4'l><'col-md-8 text-right'<'d-lg-flex justify-content-end'fB>>>t<'row align-items-center mt-3'<'mr-auto col-md-6 mb-3 mb-md-0'i><'mb-0 col-md-6'p>>",
				lengthMenu: [ 10, 20, 30, 40, 50 ],
				responsive: true,
				data: dataSetUsuarios
			});

			tableEstrategias.current = $('#estrategiasDownloads').DataTable({
				//dom: "<'row mb-3'<'col-md-4'l><'col-md-8 text-right'<'d-lg-flex justify-content-end'fB>>>t<'row align-items-center mt-3'<'mr-auto col-md-6 mb-3 mb-md-0'i><'mb-0 col-md-6'p>>",
				lengthMenu: [ 10, 20, 30, 40, 50 ],
				responsive: true,
				data: dataSetEstrategias
			});

			
			
			return function cleanUp() {
				if (tableRef.current) {
					tableRef.current.destroy();
				}

				if (tableUsuarios.current) {
					tableUsuarios.current.destroy();
				}

				if (tableEstrategias.current) {
					tableEstrategias.current.destroy();
				}
			};
			
		});

		
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div className="container">
			<div className="row justify-content-center">
				<div className="col-xl-10">
					<div className="row">
						<div className="col-xl-12">
							
							<h1 className="page-header">
								ANALYTICS
							</h1>
							
							<hr className="mb-4" />
							
							<div id="datatable" className="mb-5">
								<h4>Últimos Downloads</h4>
								<Card>
									<CardHeader className="with-btn">
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>

										<table id="datatableDefault" className="table text-nowrap w-100">
											<thead>
												<tr>
													<th>Nome</th>
													<th>Email</th>
													<th>Estratégia</th>
													<th>Data</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>Tiger Nixon</td>
													<td>System Architect</td>
													<td>Edinburgh</td>
													<td>61</td>
												</tr>
											</tbody>
										</table>
									</CardBody>
									
								</Card>
							</div>

							<hr className="mb-4" />
							
							<div id="datatable2" className="mb-5">
								<h4>Usuários</h4>
								<Card>
									<CardHeader className="with-btn">
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>

										<table id="usuariosDownload" className="table text-nowrap w-100">
											<thead>
												<tr>
													<th>Nome</th>
													<th>Email</th>
													<th>Quantidade de Downloads</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>Kaio Valente</td>
													<td>ksmvalente@gmail.com</td>
													<td>10</td>
												</tr>
											</tbody>
										</table>
									</CardBody>
									
								</Card>
							</div>

							<div id="datatable2" className="mb-5">
								<h4>Estratégias</h4>
								<Card>
									<CardHeader className="with-btn">
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>

										<table id="estrategiasDownloads" className="table text-nowrap w-100">
											<thead>
												<tr>
													<th>Estratégia</th>
													<th>Quantidade de Downloads</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>Estratégia #01</td>
													<td>50</td>
												</tr>
											</tbody>
										</table>
									</CardBody>
									
								</Card>
							</div>


						</div>
						
					</div>
				</div>
			</div>
		</div>
	)
}

export default TablePlugins;